import PropTypes from 'prop-types';
import React from 'react';

import { WHITE } from '@wetransfer/transfer/constant/colors';

const PricesSeparator = ({ className, opacity, color }) => {
  return (
    <svg
      className={className}
      width="16"
      height="45"
      viewBox="0 0 16 45"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path opacity={opacity} d="M15 1L1 44" stroke={color} />
    </svg>
  );
};

PricesSeparator.propTypes = {
  className: PropTypes.string,
  opacity: PropTypes.number,
  color: PropTypes.string,
};

PricesSeparator.defaultProps = {
  opacity: 1,
  color: WHITE,
};

export default PricesSeparator;
